module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/mobile-6f12a93f954effa93bea2dfb8957690e.jpg";